import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { ScrollSmoother } from 'gsap/ScrollSmoother';

gsap.registerPlugin(ScrollTrigger, ScrollSmoother);

export default defineNuxtPlugin((nuxtApp) => {
  let smoother;
  
  function init(callPause = false) {
    destroy();

    smoother = ScrollSmoother.create({
      normalizeScroll: true, // it forces scrolling to be done on the JavaScript thread, ensuring it is synchronized and the address bar doesn't show/hide on mobile devices
      smooth: 1, // seconds it takes to "catch up" to native scroll position
      effects: true, // look for data-speed and data-lag attributes on elements and animate accordingly
      ignoreMobileResize: true, // if true, vertical resizes (of 25% of the viewport height) on touch-only devices won't trigger a ScrollTrigger.refresh(), avoiding the jumps that can happen when the start/end values are recalculated
      smoothTouch: false // by default, ScrollSmoother will NOT apply scroll smoothing on touch-only devices (like phones) because that typically feels odd to users when it disconnects from their finger's drag position, but you can force smoothing on touch devices 
    });

    ScrollTrigger.refresh(!callPause);
    if(callPause) pause();
  }

  function destroy() {
    if(smoother) {
      smoother.kill();
      smoother = null;
    }
  }

  function pause() {
    if(smoother) smoother.paused(true);
  }

  function resume(callRefresh = false) {
    if(smoother) {
      if(callRefresh) refresh(false);
      smoother.paused(false);
    }
  }

  function refresh(boo = false) {
    ScrollTrigger.refresh(boo);
  }

  function scrollTop(val) {
    if(!smoother) return null;
    else if(!val) return smoother.scrollTop();
    else smoother.scrollTop(val);
  }

  return {
    provide: {
      initScrollSmoother: init,
      destroyScrollSmoother: destroy,
      pauseScrollSmoother: pause,
      resumeScrollSmoother: resume,
      refreshScrollSmoother: refresh,
      scrollTopScrollSmoother: scrollTop
    },
  };
});
